import Blue from "~/core";

new Blue({
  name: "da-header",
  selector: ".da-header",
  setup(header) {
    const menuBtn = header.querySelector(".da-header__menu-btn");
    const menuLinks = header.querySelectorAll(".da-header__nav-link, .da-btn");

    const mediaDown = this.$screen.lg_dn;

    function toggleMenu(forcedState) {
      if (mediaDown.matches)
        toggleAttributeValue(menuBtn, "aria-expanded", forcedState);
    }

    [menuBtn, ...menuLinks].forEach(el => {
      el.addEventListener("click", () => {
        toggleMenu(); 
      });
    });

    this.$screen.lg_dn.addListener(() => toggleMenu(false))
  }
});

function toggleAttributeValue(element, attribute, force = null) {
  element.setAttribute(
    attribute,
    force === null ? element.getAttribute(attribute) !== "true" : force
  )
}